export default __webpack_public_path__ + "static/media/jupyter.e0e612fd.png";